module.exports = __webpack_public_path__ + "img/download_black_24dp.512fc492.svg";